// extracted by mini-css-extract-plugin
export default {"title":"SelectTopUpMethod_title__S6vwL","list":"SelectTopUpMethod_list__kTW59"};